export const tokens = {
  colors: {
    blue: {
      100: "#E6F3F7", // más claro
      200: "#CCE7EF",
      300: "#DBF6FFFF", // No se usa - proto Blue-6
      400: "#99CFE0",
      500: "#437084FF", // proto Blue-4 (active sidebar item)
      600: "#214D61FF", // No se usa - proto Blue-5
      700: "#0B3E5F80", // proto Blue-3 (50% placeholder-border inputs)
      800: "#0B3E5FFF", // proto Blue-2
      900: "#0D3547FF", //proto Blue-1
      1000: "#072631", // más oscuro
    },

    basics: {
      0: "#ffffffff", // White
      100: "#F2F7FFFF", // White-1
      200: "#F9FAFB",
      300: "#F3F4F6",
      400: "#E5E7EB",
      500: "#D1D5DB",
      600: "#FFFFFF99", // White 60% (fill inputs)
      700: "#FFFFFF80",// White 50%
      800: "#FFFFFF33", // White 20%
      900: "#FFFFFF1A", // White 10%
      1000: "#9CA3AF",
      1100: "#6B7280",
      1200: "#4B5563",
      1300: "#374151",
      1400: "#1F2937",
      1500: "#7F7F7FFF", // Grey-1 (disabled buttons)
      1600: "#777777FF", // Grey-3
      1700: "#0000004D", // Grey-2
      1800: "#000000FF", // Black
      1900: "#4B4B4BFF", // Grey-4#4B4B4B
    },
    secondary: {
      500: "#68BBCE",
      600: "#ffffff0d"
    },
    /**
     * Gradientes & Transparencies
     */
    transparencies: { 0: "#FFFFFF1A", 50: "#E6E2FF4D" },
    gradient: {
      startEnd: "#03a1c4ff", // proto Gradient-start-end
      middle: "#683b97ff", // proto Gradient-middle
      primary:
        "linear-gradient(180deg, #68BBCE -3.1%, #9B88B8 49.94%, #68BBCE 106.2%)",
      secondary: "linear-gradient(135deg, #0B3E5F 0%, #68BBCE 100%)",
      radial:
        "radial-gradient(122.46% 120.83% at 76.05% -5.13%, #03A1C4 0%, #683B97 47%, #03A1C4 96.83%)",
    },

    semantic: {
      success: "#10B981",
      successLight: "#D1FAE5",
      warning: "#F59E0B",
      warningLight: "#FEF3C7",
      error: "#EF4444",
      errorLight: "#FEE2E2",
      info: "#3B82F6",
      infoLight: "#DBEAFE",
    },
    /**
     * Tooltip & placeholder & input
     */
    inputBackground: "#8fb6c7",
    tooltip: "#214D61",
    placeholder: "#0d354780",
  },

  // Tipografía + lineHeight por escala
  typography: {
    fontFamily: {
      primary: "'Poppins', Inter, system-ui, sans-serif",
      mono: "'JetBrains Mono', 'Fira Code', monospace",
    },
    fontSize: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "18px",
      xl: "20px",
      "2xl": "24px",
      "3xl": "30px",
      "4xl": "36px",
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      xs: "1.25",
      sm: "1.4",
      md: "1.5",
      lg: "1.6",
      xl: "1.75",
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },

  // Spacing / Radius
  spacing: {
    xs: "4px",
    sm: "8px",
    mmd: "12px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
    "3xl": "64px",
    "4xl": "96px",
  },

  borderRadius: {
    none: "0",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    full: "9999px",
  },

  // Motion: duraciones UX + presets de comodidad
  transitions: {
    duration: {
      instant: "50ms",
      quick1: "100ms",
      quick2: "150ms",
      quick3: "200ms",
      moderate1: "300ms",
      moderate2: "400ms",
      slow: "500ms",
      extraSlow: "1000ms",
      specialEffect1: "1500ms",
      specialEffect2: "2000ms",
    },
    // Presets listos para usar
    fast: "150ms ease-in-out",
    normal: "200ms ease-in-out",
    slow: "300ms ease-in-out",
  },

  // Sombras / zIndex
  shadows: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
  },

  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
    drawer: 1500,
    toast: 1600,
  },

  // Breakpoints numéricos
  breakpoints: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
  },
} as const;

export type Tokens = typeof tokens;
